import { createContext, useContext, useState } from 'react'

const CallPhoneContext = createContext()

export const CallPhoneProvider = ({ children }) => {
  const [openModalCallPhone, setOpenModalCallPhone] = useState(false)
  const [numberPhone, setNumberPhone] = useState('')

  const isOpen = !!openModalCallPhone

  const openCallPhone = (phone) => {
    setNumberPhone(phone)
    setOpenModalCallPhone(true)
  }

  const closeCallPhone = () => {
    setNumberPhone('')
    setOpenModalCallPhone(false)
  }

  function handleNumberTelephone(number) {
    setNumberPhone((prev) => (prev ? `${prev}${number}` : String(number)))
  }

  function clearNumberTelephone() {
    setNumberPhone('')
  }

  function deleteNumberTelephone() {
    setNumberPhone((prev) => prev.slice(0, -1))
  }

  return (
    <CallPhoneContext.Provider
      value={{
        openModalCallPhone,
        openCallPhone,
        closeCallPhone,
        numberPhone,
        isOpen,
        handleNumberTelephone,
        clearNumberTelephone,
        deleteNumberTelephone,
      }}
    >
      {children}
    </CallPhoneContext.Provider>
  )
}

export const useModalCallPhone = () => {
  const context = useContext(CallPhoneContext)

  if (!context) {
    throw new Error('useModalCallPhone must be used within a CallPhoneProvider')
  }

  return context
}
